import React, { useEffect, useState, useContext } from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import axios from 'axios';
import { Container } from '@mui/system';
import Grid from '@mui/material/Grid';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import LoaderDialog from './LoaderDialog'
import { AuthContext } from '../authContext/AuthContext'
import { getPriceNumber, getQtyNumber } from '../util.js'

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const ItemWiseSummaryReport = ({startDate, endDate, shopKeys}) => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false)
  const { user, shop } = useContext(AuthContext);
  useEffect(() => {
    const loadData = async() => {
      setLoading(true)
      try {
        const columns = [
          {"field": "id", "headerName": "#", "key":"aa"}, 
          {"field": "itemKey", "headerName": "Item Key"},
          {"field": "itemName", "headerName": "Item Name", width: 350},
          {"field": "quantity", "headerName": "Quantity"},
          {"field": "amount", "headerName": "Amount"}]
        let d = new Date(endDate)
		d.setDate(d.getDate() + 1)
        const newEndDate = d.toISOString().split('T')[0]
        const res = await axios.post("/orders/itemWiseSummaryReport", {startDate, endDate: newEndDate, shopKeys}, {headers: {token:"Bearer " + user.token, shopkey: shop.shopkey}})
        const sortedData = res.data.sort((a,b) => {return b.quantity - a.quantity});
        let sd = []
        sortedData.map((item, index)=> sd.push({"id": index + 1, "itemKey": item._id.itemKey, "itemName": item._id.itemName, "quantity": getQtyNumber(item.quantity).toFixed(3), "amount": getPriceNumber(item.amount).toFixed(2)}))
          if(sd) {
          setData({"rows": sd, "columns": columns})
        }
        setLoading(false)
      } catch (err) {
        console.log(err)
        setLoading(false)
      }
    }
    loadData();
  },[startDate, endDate, user, shop, shopKeys]);
 
  
  return (   
    <Container maxWidth="false" disableGutters sx={{height: "85vh", width: "100vw"}}>       
      <LoaderDialog open={loading} title="Loading Report Data ..."/>
      <Grid container>
        {data && <DataGrid {...data} components={{ Toolbar: GridToolbar }} sx={{height: "85vh", width: "100vw"}}/>}
      </Grid>
    </Container>
  )
}

export default ItemWiseSummaryReport
